export default {
  fi: {
    ServiceEventCompleteReminderForm: {
      serviceEvents: 'Huollot',
    },
  },
};
